// extracted by mini-css-extract-plugin
export default {"productGrid":"GZ-z","centerLink":"HZ-z","productSection":"IZ-z","item":"JZ-z","ctaButton":"KZ-z"};